import React, {useState} from 'react';
import {Form, Input, Select, Switch, Button, Card, Row, Col, Typography, Modal, message, Space} from 'antd';
import {UserOutlined, PhoneOutlined, LockOutlined} from '@ant-design/icons';
import './Common.module.css';
import styles from './Common.module.css';
import {useSelector} from "react-redux";
import {selectRechargeUserInfo} from "../../userManager/UserManagerSlice";
import {rechargeRequest} from "../api";

const {Title} = Typography;
const {Option} = Select;

const { TextArea } = Input;
const AddAccountForm = (props) => {
    const [form] = Form.useForm();
    const rechargeUserInfo = useSelector(selectRechargeUserInfo)

    const onFinish = (values) => {
        console.log(rechargeUserInfo)
        // 这里可以添加API调用或其他提交逻辑
        var beizhu = values.beizhu === undefined ? '' : values.beizhu;
        // 调用 API
        rechargeRequest(rechargeUserInfo.username,
            values.points,
            beizhu,
            rechargeUserInfo.type,
            "",
            (data) => {
                console.log(data);
                if (data.ret === '1') {
                    form.resetFields();
                    message.success("添加成功", 1);
                    props.updateData();
                    props.closeCommonModal()
                } else {
                    message.error(data.msg, 1);
                }
            });
    };


    const closeCommon = () => {
        props.closeCommonModal()
    };

    return (
        <Modal
            maskClosable={false}
            // visible={true}
            open={props.openStatus}
            onCancel={closeCommon}
            footer={null} // 设置 footer 为 null 移除默认按钮
            width={800}
            // className="add-account-container"
        >
            {/*<Card className={styles["form-card"]} span={20}>*/}
                <div className={styles["form-title"]}>积分充值</div>
                <Form
                    form={form}
                    layout="horizontal"
                    onFinish={onFinish}
                >
                    <Form.Item
                        label="充值积分"
                        name="points"
                        rules={[{required: true, message: '请输入积分数量'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="xxx积分值"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="备注"
                        name="beizhu"
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <TextArea
                            placeholder='输入备注信息'

                            // value={tishiValue}
                            // onChange={changeTishiFn}
                            // readOnly={disableCreate}
                        />
                    </Form.Item>
                    <Form.Item className={styles["form-actions"]}>

                        <Button

                            size="large"
                            // onClick={() => form.resetFields()}
                            onClick={(e)=>{
                                // props.cancel()
                                closeCommon()
                            }}
                        >
                            取消
                        </Button>

                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            style={{marginLeft: 16}}
                        >
                            确认
                        </Button>

                    </Form.Item>
                </Form>
            {/*</Card>*/}
        </Modal>
    );
};

export default AddAccountForm;

